import axios from "axios";
import { apiErrorHandler } from "./helper/handler";

const prefix = "text-setting";

const GET_TEXT_SETTING_URL = `${prefix}/get`;
const UPDATE_TEXT_SETTING_URL = `${prefix}/update`;

/**
 * @func getTextSetting
 * @desc get text setting data
 * @author izeberg
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {Object} text setting object
 */
export const getTextSetting = async signal => {
    try {
        const { data, status } = await axios.get(GET_TEXT_SETTING_URL, {
            signal,
        });
        if (status === 200) {
            return data?.data;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "getTextSetting");
        if (err) throw err;
        return undefined;
    }
};
/** End @func getTextSetting */

/**
 * @func updateTextSetting
 * @desc update text setting
 * @author izeberg
 * @param {Object} body - update text setting body
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {boolean} update status
 */
export const updateTextSetting = async (body, signal) => {
    try {
        const { status } = await axios.put(`${UPDATE_TEXT_SETTING_URL}`, body, {
            signal,
        });
        if (status === 200) {
            return true;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "updateTextSetting");
        if (err) throw err;
        return undefined;
    }
};
/** End @func updateTextSetting */
